import * as Yup from 'yup';

export const _reasonForReferralState = (function () {
    let mainTypeSupport = [];
    let contactInformationAround = "";
    let detailsOfDisabilities = "";
    let riskToStaff = "";
    let riskDetails = "";
    let whatWillHappenNext = "";
    let involvedOrganisationOrProfession = "";
    let organisationDetails = "";
    let files = [];

    const getMainTypeSupport = function () { return mainTypeSupport; };
    const setMainTypeSupport = function (val) { mainTypeSupport = val };
    const getContactInformationAround = function () { return contactInformationAround };
    const setContactInformationAround = function (val) { return contactInformationAround = val };
    const getDetailsOfDisabilities = function () { return detailsOfDisabilities; };
    const setDetailsOfDisabilities = function (val) { detailsOfDisabilities = val };
    const getRiskToStaff = function () { return riskToStaff; };
    const setRiskToStaff = function (val) { riskToStaff = val };
    const getRiskDetails = function () { return riskDetails; };
    const setRiskDetails = function (val) { riskDetails = val };
    const getWhatWillHappenNext = function () { return whatWillHappenNext; };
    const setWhatWillHappenNext = function (val) { whatWillHappenNext = val };
    const getInvolvedOrganisationOrProfession = function () { return involvedOrganisationOrProfession; };
    const setInvolvedOrganisationOrProfession = function (val) { involvedOrganisationOrProfession = val };
    const getOrganisationDetails = function () { return organisationDetails; };
    const setOrganisationDetails = function (val) { organisationDetails = val };
    const getFiles = function () { return files; };
    const setFiles = function (val) { files = val };

    const resetReasonState = function () {
        setMainTypeSupport("");
        setContactInformationAround("");
        setDetailsOfDisabilities("");
        setRiskToStaff("");
        setRiskDetails("");
        setWhatWillHappenNext("");
        setInvolvedOrganisationOrProfession("");
        setOrganisationDetails("");
        setFiles([]);
      };

    return {
        getMainTypeSupport: getMainTypeSupport,
        setMainTypeSupport: setMainTypeSupport,
        getContactInformationAround: getContactInformationAround,
        setContactInformationAround: setContactInformationAround,
        getDetailsOfDisabilities: getDetailsOfDisabilities,
        setDetailsOfDisabilities: setDetailsOfDisabilities,
        getRiskToStaff: getRiskToStaff,
        setRiskToStaff: setRiskToStaff,
        getRiskDetails: getRiskDetails,
        setRiskDetails: setRiskDetails,
        getWhatWillHappenNext: getWhatWillHappenNext,
        setWhatWillHappenNext: setWhatWillHappenNext,
        getInvolvedOrganisationOrProfession: getInvolvedOrganisationOrProfession,
        setInvolvedOrganisationOrProfession: setInvolvedOrganisationOrProfession,
        getOrganisationDetails: getOrganisationDetails,
        setOrganisationDetails: setOrganisationDetails,
        getFiles: getFiles,
        setFiles: setFiles,
        resetReasonState: resetReasonState
    }

})();

const yupValidation = Yup.object().shape({
    contactInformationAround: Yup.string()
                                .required("Enter more information about your reason for contact today")
                                .max(950, (validationObj) => {return `Information you provide must be ${validationObj.max} characters or less`}),
    detailsOfDisabilities: Yup.string()
                                .required("Enter details of any disabilities and/or physical access needs of person being referred")
                                .max(450, (validationObj) => {return `Details of disabilities and/or physical access needs must be ${validationObj.max} characters or less`}),
    riskToStaff: Yup.string()
                    .required("Select if there are any risks to staff")
                    .nullable(),
    whatWillHappenNext: Yup.string()
                            .notRequired()
                            .max(150, (validationObj) => {return `What do you hope will happen next must be ${validationObj.max} characters or less`})
                            .nullable(),
    involvedOrganisationOrProfession: Yup.string()
                            .required("Enter details of any other professionals or organisations involved")
                            .nullable(),

    organisationDetails: Yup.string().trim().ensure().when('involvedOrganisationOrProfession', {
        is: (org) => org === 'yes',
        then: Yup.string().trim()
                            .required("Enter details of any other professionals or organisations involved ")
                            .max(150, (validationObj) => {return `Details of any other professionals or organisations involved must be ${validationObj.max} characters or less`}),
    }),

    riskDetails: Yup.string().trim().ensure().when('riskToStaff', {
        is: (risk) => risk === 'yes',
        then: Yup.string().trim().required("Enter details of risks to staff ")
            .max(150, (validationObj) => {return `Details of risk to staff must be ${validationObj.max} characters or less`}),
    })
})
    .when((value, schema) => {
        let support = _reasonForReferralState.getMainTypeSupport();
        let supportList = [];
        support?.map((s) => { supportList.push(s) });
        if (supportList.length === 0) {
            return schema.shape({
                mainTypeSupport: Yup.object()
                                    .required("Select the main type of support the person being referred needs")
                                    .nullable()
            });
        }
    })

export const formOptions = yupValidation;